import AppDialog from '../../components/app_dialog'
import { Button, Text } from '@cinesend/ui-kit'
import { Warning } from '@phosphor-icons/react'
import { useSnackbar } from '../../hooks/use_snackbar'
import { useQueryClient } from '@tanstack/react-query'
import useStore from '../../hooks/use_store'
import { useState } from 'react'

const GenerateSnapshotButton = ({ cycleID, hasErrors, queryKey }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { addMessage } = useSnackbar()
  const queryClient = useQueryClient()
  const { createModel } = useStore()

  const generateSnapshot = () =>
    createModel.mutate(
      {
        endpoint: 'snapshots',
        data: {
          cycle_id: cycleID,
        },
      },
      {
        onSuccess: ({ data }) => {
          queryClient.setQueryData(queryKey, (oldData) => {
            if (!oldData?.data) {
              return {
                data: [data.snapshot],
              }
            }
            return {
              ...oldData,
              data: [data.snapshot, ...oldData.data],
            }
          })
        },
        onError: (error) => {
          addMessage(`Error triggering snapshot generation: ${error.response?.data?.message || error.message}`, 'error')
        },
      }
    )

  return (
    <>
      <Button
        disabled={createModel.isLoading}
        variant={hasErrors ? 'destructive' : 'primary'}
        trailingIcon={hasErrors ? <Warning size={20} weight='regular' aria-hidden='true' /> : null}
        onClick={() => (hasErrors ? setModalOpen(true) : generateSnapshot())}
      >
        Create submission
      </Button>
      {modalOpen && (
        <AppDialog
          title='This cycle has errors'
          onClose={() => setModalOpen(false)}
          confirmText='Create submission with errors'
          confirmVariant='destructive'
          onConfirm={() => {
            setModalOpen(false)
            generateSnapshot()
          }}
        >
          <Text as='p' variant='sm' tone='secondary'>
            You're about to generate a submission despite errors being present in the cycle. Are you sure you want to do
            this?
          </Text>
        </AppDialog>
      )}
    </>
  )
}

export default GenerateSnapshotButton
